/* eslint-disable quotes */
/* eslint-disable react/no-danger */
import React from 'react';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import Utils from 'Utils/utils';
import {
  ConciergeListUploadPopup,
  conciergeListUploadState,
} from 'Components/common/consiergeListUploadPopup';
import LoadingWrapper from 'Components/common/loadingWrapper';
import { toasterState } from 'Components/common/toaster';

import { ReactComponent as DownloadIcon } from 'Assets/svg/download-icon.svg';
import { ReactComponent as InProgressIcon } from 'Assets/svg/processing.svg';
import { ReactComponent as ProcessCompletedIcon } from 'Assets/svg/process-completed.svg';
import emptyListIcon from 'Assets/png/emptySuppressionList.png';
import conciergeSampleCsvFile from 'Assets/csv/Concierge_Sample_File.csv';
import { confirmationPopupState } from 'Components/common/confirmationPopup';

const frequentlyAskedQuestions = [
  {
    indexNo: '01',
    question: 'Does Adapt provide concierge services? How do I avail them?',
    answer:
      "Yes we do. Adapt's concierge services include providing customers with mobile phone numbers of contacts from outside our database. You can avail this service by placing a request. Our research team will fetch mobile numbers of the requested contacts. Once the list is ready, you will be notified via email.",
  },
  {
    indexNo: '02',
    question:
      "Do Adapt's regular pricing plans include concierge service charges?",
    answer:
      "No they don't. Concierge services are charged separately from your regular subscriptions. They also follow a different credit system. To increase your credits, you can either get in touch with your customer success representative or write to <a href='mailto:success@adapt.io' target='_blank'>success@adapt.io</a>.",
  },
  {
    indexNo: '03',
    question: 'How do I submit a request?',
    answer: `You can upload the list of contacts with the email address and (or) LinkedIn URL. <a href="${conciergeSampleCsvFile}" >Click here</a> to download a sample file. `,
  },
];

const FrequentlyAskedSection = () => {
  return (
    <div className="frequently-asked-section">
      <div className="title">Frequently Asked Questions</div>
      <div className="questions-list">
        {frequentlyAskedQuestions.map((item, index) => {
          const { indexNo, question, answer } = item;
          return (
            <div className="question-item" key={`frequet-question${index}`}>
              <div className="left-wrap">
                <div className="round-wrap">{indexNo}</div>
                <div className="line-wrap" />
              </div>
              <div className="right-wrap">
                <div
                  className="question-title"
                  dangerouslySetInnerHTML={{ __html: question }}
                />
                <div
                  className="question-answer"
                  dangerouslySetInnerHTML={{ __html: answer }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const EmptyListFound = props => {
  return (
    <div className="empty-list-wrap">
      <div className="empty-list-section">
        <img
          className="no-results-logo"
          src={emptyListIcon}
          alt="No results found"
        />
        <div className="no-results-text">
          You have not submitted any requests yet! <br />
          Please create one using the &quot;Submit a request&quot; button on
          top.
        </div>
      </div>
    </div>
  );
};

const ConciergeListHeader = observer(() => {
  const { userInfo } = userDetail;
  const { conciergeCredits } = userInfo;
  const addNewConciergeList = () => {
    if (Utils.isConciergeEnabled())
      if (conciergeCredits === 0) {
        confirmationPopupState.setPopupValues({
          title: '',
          content:
            '<br />Sorry, you don’t have enough concierge credits to submit a new request! Write to us now at <a href="mailto:success@adapt.io" target="_blank">success@adapt.io</a> and get a credit top up immediately.',
          actionBtnText: 'OK',
          callback: () => {},
          needCancelBtn: false,
          showCloseBtn: false,
        });
        confirmationPopupState.setShowPopup(true);
      } else if (conciergeListUploadState.isActiveInprogressList) {
        confirmationPopupState.setPopupValues({
          title: '',
          content:
            '<br />Another request is being processed currently. Kindly wait for it to complete to place the next request.',
          actionBtnText: 'OK',
          callback: () => {},
          needCancelBtn: false,
          showCloseBtn: false,
        });
        confirmationPopupState.setShowPopup(true);
      } else {
        conciergeListUploadState.setShowCreateList(true);
      }
    else Utils.showUserPricingPopup(true, '', true);
  };
  return (
    <div className="concierge-list-header">
      <div className="page-title-text">Concierge Services</div>
      <div className="add-new-list" onClick={addNewConciergeList}>
        Submit a request
      </div>
    </div>
  );
});

const ConciergeList = observer(props => {

  const { getListLoading, conciergeListEntries } = conciergeListUploadState;

  React.useEffect(() => {
    if (Utils.isConciergeEnabled() && !getListLoading)
      conciergeListUploadState.getConciergeList();
  }, [userDetail.onFirstLoad, userDetail.featureFlags]);

  return (
    <>
      <ConciergeListUploadPopup />
      <div className="concierge-list-wrapper">
        <ConciergeListHeader />
        {getListLoading ? (
          <div className="contact-list">
            <LoadingWrapper show={getListLoading} />
          </div>
        ) : Utils.isConciergeEnabled() && conciergeListEntries.length > 0 ? (
          <div className="contact-list">
            <div className="contact-list-wrap">
              <div className="contact-header">
                <div className="contact-header-item">List Name</div>
                <div className="contact-header-item">Contacts Uploaded</div>
                <div className="contact-header-item">Mobile Numbers Found</div>
                <div className="contact-header-item align-center">Actions</div>
                <div className="contact-header-item align-center">Status</div>
              </div>
              {conciergeListEntries.map((item, index) => {
                const {
                  responseFile = null,
                  totalCount = null,
                  processedCount = null,
                  listName = null,
                  creditsConsumed = null,
                  status = null,
                } = item;
                return (
                  <div className="contact-item" key={`concierge_list_${index}`}>
                    <div className="contact-content-item">
                      {Utils.upperCaseFirstCharacter(listName)}
                    </div>
                    <div className="contact-content-item">
                      {Utils.usNumberFormat(totalCount)}
                    </div>
                    <div className="contact-content-item">
                      {creditsConsumed !== null
                        ? Utils.usNumberFormat(creditsConsumed)
                        : '-'}
                    </div>
                    <div className="contact-content-item action-icons">
                      {status === 'INPROGRESS' ? (
                        '-'
                      ) : (
                        <a
                          href={responseFile}
                          download={responseFile}
                          title="Download Link"
                        >
                          <DownloadIcon
                            className="svg-icon"
                            title="Download User"
                          />
                        </a>
                      )}
                    </div>
                    <div className="contact-content-item action-icons list-status">
                      {status === 'INPROGRESS' ? (
                        <>
                          <InProgressIcon
                            className="svg-icon"
                            title="inprogress User"
                          />
                          Processing
                        </>
                      ) : (
                        <>
                          <ProcessCompletedIcon
                            className="svg-icon"
                            title="process completed User"
                          />
                          Complete
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <EmptyListFound />
        )}
        <FrequentlyAskedSection />
      </div>
    </>
  );
});

export default ConciergeList;
export { ConciergeList };
